import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styles from './EcsPortal.module.scss';
import { clickTracker, getProjectId } from '../../lib/common';
import { handleImpressionsTrack } from '../../api';
import { useAuth } from '../../contexts/auth';

export default function Campaigns({ campaigndetails }) {
  const [activeIndex, setActiveIndex] = useState(-1);
  const statusColor = {
    active: '#40bf20',
    stopped: 'rgb(227 27 27)',
  };
  const projectId = getProjectId();
  const [authState] = useAuth();

  return (
    <div>
      {campaigndetails.map((item, index) => {
        return (
          <div
            aria-label="ecs_campaigns_change"
            tabIndex={0}
            role="button"
            onKeyDown={() => {}}
            className={`${styles.Summary}  ${activeIndex === index ? styles.Summary__Active : ''} mt-10`}
            key={index}
            onClick={async () => {
              if (activeIndex !== index) {
                await clickTracker(`ecs_details_${item.camp_name}`, `ecs_details`);
                if (projectId === 'csportal') {
                  const liVal = 'click';
                  const liTrd = `faq_activationstatus`;
                  const faqTypeVal = '';
                  const othersData = [];
                  const llTrd = 'issue_ecs';
                  await handleImpressionsTrack(liVal, liTrd, faqTypeVal, othersData, llTrd, authState);
                }
              }
              setActiveIndex(index === activeIndex ? -1 : index);
            }}
          >
            <div className={`${styles.Summary__Pannel}`}>
              <div className={`${styles.Summary__title} font13 fw500 color111`}>{item.camp_name}</div>
              <div className={`${styles.Summary__Drop__Icon} csicon`} />
            </div>
            <div className={`${styles.Summary__Details}`}>
              {item.campaigns ? (
                item.campaigns.map((_item) => {
                  return (
                    <>
                      <div className={`${styles.Summary__ItemList}`}>
                        <div className={`${styles.Summary__ItemLable} font13 fw500 color777`}>Campaign Name: </div>
                        <div className={`${styles.Summary__Item} ${styles.Summary__Date} font13 fw600 color111`}>
                          {_item.camp_name}
                        </div>
                      </div>
                      <div className={`${styles.Summary__ItemList}`}>
                        <div className={`${styles.Summary__ItemLable} font13 fw500 color777`}>Signed Date :</div>
                        <div className={`${styles.Summary__Item} ${styles.Summary__Date} font13 fw600 color111`}>
                          {_item.entry_date}
                        </div>
                      </div>
                      <div className={`${styles.Summary__ItemList}`}>
                        <div className={`${styles.Summary__ItemLable} font13 fw500 color777`}>Status :</div>
                        <div
                          className={`${styles.Summary__Item} ${styles.Summary__Status} font13 fw600 `}
                          style={{ color: statusColor[item.camp_status], textTransform: 'capitalize' }}
                        >
                          {item.camp_status}
                        </div>
                      </div>
                      <hr />
                    </>
                  );
                })
              ) : (
                <>
                  <div className={`${styles.Summary__ItemList}`}>
                    <div className={`${styles.Summary__ItemLable} font13 fw500 color777`}>Signed Date :</div>
                    <div className={`${styles.Summary__Item} ${styles.Summary__Date} font13 fw600 color111`}>
                      {item.entry_date}
                    </div>
                  </div>
                  <div className={`${styles.Summary__ItemList}`}>
                    <div className={`${styles.Summary__ItemLable} font13 fw500 color777`}>Status :</div>
                    <div
                      className={`${styles.Summary__Item} ${styles.Summary__Status} font13 fw600 `}
                      style={{ color: statusColor[item.camp_status], textTransform: 'capitalize' }}
                    >
                      {item.camp_status}
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
}

Campaigns.propTypes = {
  campaigndetails: PropTypes.array,
};
